import type React from "react";

const RecommendedFor: React.FC = () => {
	const recommendations = [
		{ id: 1, text: "新しいスキルを身につけたい" },
		{ id: 2, text: "自己学習のモチベーションを高めたい" },
		{ id: 3, text: "一緒に学べる仲間がほしい" },
		{ id: 4, text: "他の人と知識やアイデアを交換したい" },
		{ id: 5, text: "様々な世代と交流してみたい" },
		{ id: 6, text: "今の自分をもっと成長させたい" },
	];

	return (
		<section className="py-16 bg-gray-100">
			<div className="container mx-auto">
				<h2 className="text-3xl font-bold text-center mb-12">
					こんな方におすすめです
				</h2>
				<ul className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-md">
					{recommendations.map((recommendation) => (
						<li
							key={recommendation.id}
							className="flex items-center mb-4 text-lg font-bold"
						>
							<span className="mr-2 text-green-500">✅</span>
							{recommendation.text}
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};

export default RecommendedFor;
